import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_JOURNAL_REPORTS } from '@/api/endpoints';
import { JOURNAL_REPORTS_QUERY_KEY } from '@/api/queryKeys';
import type { JournalId, JournalReports } from '@/types/journal';
import type { StudyYearPeriod } from '@/types/overview';
import { unwrapAxiosResponse } from '@/utils/axios';
import { toApiDate } from '@/utils/date';
import { getJournalKey } from '@/utils/journal';

export const useJournalReports = (
  journalId: JournalId | undefined,
  period: StudyYearPeriod,
) => {
  const from = toApiDate(period.from);
  const to = toApiDate(period.to);

  return useQuery({
    queryKey: [
      ...JOURNAL_REPORTS_QUERY_KEY,
      journalId && getJournalKey(journalId),
      from,
      to,
    ],
    enabled: !!journalId,
    queryFn: () =>
      apiClient
        .get<JournalReports>(API_JOURNAL_REPORTS, {
          params: { from, to, ...journalId },
        })
        .then(unwrapAxiosResponse),
    placeholderData: keepPreviousData,
  });
};
